import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Award, Trophy } from 'lucide-react';
import { AWARD_LABELS, AWARD_KEYS } from './qbAwards';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function QBAwardsTab({ selectedWeek, roster }) {
  const [awards, setAwards] = useState(null);

  useEffect(() => {
    if (!selectedWeek) return;
    axios.get(`${API}/qb/awards/${selectedWeek}`).then(r => setAwards(r.data)).catch(() => setAwards({}));
  }, [selectedWeek]);

  if (!awards) return <div className="text-center py-12 text-slate-500">Loading awards...</div>;

  const byId = Object.fromEntries(roster.map(qb => [qb.player_id, qb]));
  const given = AWARD_KEYS.filter(k => awards[k] && byId[awards[k]]);

  return (
    <div data-testid="awards-section">
      <h2 className="text-2xl font-bold text-[#001f3f] mb-6 flex items-center gap-2">
        <Award className="h-6 w-6" /> Week {selectedWeek} Awards
      </h2>
      {given.length === 0 ? (
        <div className="text-center py-12 text-slate-500" data-testid="awards-empty">Awards for Week {selectedWeek} haven't been announced yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {given.map(k => {
            const qb = byId[awards[k]];
            return (
              <div key={k} className="bg-white rounded-xl shadow p-5 flex items-center gap-4" data-testid={`award-card-${k}`}>
                {qb.photo_url ? (
                  <img src={qb.photo_url} alt={qb.name} className="w-16 h-16 rounded-full object-cover" />
                ) : (
                  <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: qb.color }}>{qb.name?.charAt(0)}</div>
                )}
                <div>
                  <div className="text-xs uppercase tracking-wider text-yellow-600 font-bold flex items-center gap-1"><Trophy className="w-3 h-3" />{AWARD_LABELS[k]}</div>
                  <div className="font-bold text-lg text-[#001f3f]">{qb.name}</div>
                  <div className="text-sm text-slate-500">{qb.school}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
